module.exports = __webpack_public_path__ + "img/logo-asociados.65b0625c.png";